export default __webpack_public_path__ + "static/media/480_dummy-2014-store03-de.96cae328.png";